import React, { Component } from 'react';
import classes from './LandingPage.css';

import Typography from '@material-ui/core/Typography';

import Spinner from '../../components/UI/LoadingSpinner'

import ScrollTrigger from 'react-scroll-trigger';
import scrollToComponent from 'react-scroll-to-component';

import TopList from '../TopList/TopList';
import WinList from '../WinList/WinList';

import MainSplash from '../../components/SplashScreen/SplashScreen';
import QuizIntro from '../../components/QuizIntro/QuizIntro';

import { withRouter } from 'react-router-dom';

import ReactGA from 'react-ga';

/* redux stuff*/
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';


class LandingPage extends Component {

	onEnterViewport = (nr) => {
		if (this.props.rdy) {
			//this.setState({position: nr});
			this.props.onUpdateLPPosition(nr);
		}
	}
	
	triggerAnimation = (event,ref,anim,delay) => {
		let del;
		if (delay!==undefined) {
			del=delay;
		} else {
			del='';
		}
		if (!ref.element.classList.contains('animated')) {
			ref.element.className="animated "+anim+" "+del;
		}
	}

	doClick = (name) => {
		scrollToComponent(this[name], {align:'top',offset:-117,ease:'out-quad', duration:500})
		this.props.onUpdateLPElement("");
	}

	doClick2 = () => {
		this.props.history.push('/pravila');
		this.props.onUpdateLPElement("zero");
		this.props.onUpdateLPPosition(0);
		this.props.onUpdatePath('/pravila');
	}

	componentWillReceiveProps(nextProps){
		//console.log('nextProps in LP: ', nextProps);
		if (nextProps.lpElement!=="") {
			this.doClick(nextProps.lpElement);
		}
	}

	componentWillMount () {
		this.props.spinnerChange(true);
	}

	componentDidMount() {
		//console.log(this.props);
		//const { history } = this.props
		this.props.onRdyLanding();
		this.props.spinnerChange(false);
		//this.props.reportPosition(6);
		this.props.onUpdateLPPosition(6);
				//this.setState({ready:true});
		/*
		if (this.isAuthorised()) {
			history.push('/signin')
		}
		*/
	};
	
	render () {
		let spin = null;
		if (this.props.spin) {
			spin = <Spinner/>
		}

		return (
		<div className={classes.main} ref={(childForm) => {this.doclick = childForm}} location={this.props.curPath}>
			<div className={classes.root}>
			<ScrollTrigger onEnter={() => this.onEnterViewport(0)} />
			{/*<!-- carousel comp -->*/}
			<div className={classes.hero}
			  ref={ (div) => {this.zero = div}}
			>
					<MainSplash />
				<ScrollTrigger onEnter={() => this.onEnterViewport(0)} />
			</div>

			<ScrollTrigger onEnter={() => this.onEnterViewport(1)}/>
			{/*<!-- Kako se ucestvuje -->*/}
			<div 
				className={classes.hero}
			  ref={ (div) => {this.one = div}}
			>
				<div className={classes.content}
					style={{backgroundColor:'rgb(25, 89, 160)'}}
				>
					<div style={{width:'100%',textAlign:'center'}} >
						<h1 className={classes.h1Custom}>Kako se učestvuje?</h1>
					</div>
					<p className={classes.bodyText}>
						<span className={classes.h2Custom}>REGISTRUJTE SE </span> Pre polaganja ispita, potrebno je da se registrujete i na taj način kreirate svoj nalog. Svaki sledeći put kada budete želeli da učestvujete, biće dovoljno da se prijavite pomoću e-mail adrese i lozinke. 
					</p>
					<p className={classes.bodyText}>
						<span className={classes.h2Custom}>INFORMIŠITE SE </span>Toplo preporučujemo da pre polaganja ispita pročitate <a onClick={ () => {this.doClick2()}}>“Pravila i uslove učestvovanja”</a> u kojima ćete naći detaljno objašnjenje o tome kako se učestvuje, ko može da se prijavi, koji su kriterijumi za osvajanje nagrada, kojom se dinamikom dodeljuju nagrade i mnoge druge korisne informacije. 
					</p>
					<p className={classes.bodyText}>
						<span className={classes.h2Custom}>ZAPOČNITE ISPIT </span>Imajte na umu da Durex ispit možete polagati samo jedanput dnevno! Jednom kada potvrdite da želite da polažete ispit, pitanja kreću sa učitavanjem. Obratite pažnju da, ukoliko iz bilo kog razloga dođe do prekida ispita, nećete imati pravo da ponovo polažete ispit istog dana.<br/><br/><strong>Cilj takmičenja je odovoriti tačno na što više pitanja u najkraćem mogućem roku!</strong>
					</p>
					<p className={classes.bodyText}>
						<span className={classes.h2Custom}>UPIŠITE OCENU </span>Ukoliko ste zadovoljni rezultatom ispita, nakon što odgovorite na svih 10 pitanja, potrebno je da upišete ocenu kako bi se vaš rezultat našao na TOP LISTI. Uvid u sopstvene rezultate dostupan vam je u okviru vašeg naloga.
					</p>
					<p className={classes.bodyText}>
						<span className={classes.h2Custom}>PRATITE REZULTATE </span>U okviru sekcije DOBITNICI, možete pratiti rezultate i imena dobitnika dnevnih i nedeljnih nagrada, kao i glavne nagrade na kraju takmičenja. Ukoliko ste jedan od dobitnika, očekujte e-mail sa obaveštenjem o osvojenoj nagradi, na koji ćete moći da nam pošaljete podatke za dostavu iste.
					</p>
					<p className={classes.bodyText}>
						<span className={classes.h2Custom}>ZABAVITE SE </span>Nadamo se da će vam ovaj ispit biti zabavan i da ćete naučiti puno korisnih stvari koje možda niste imali priliku da čujete ili iskusite ranije. 
					</p>
					<p className={classes.bodyText2}>
						A sada, pokažite nam koliko dobro poznajete materiju. ;)<br/>Držimo vam palčeve!
					</p>
			  </div>
			</div>

  

  
  
			{/*<!-- Kviz -->*/}
			<ScrollTrigger onEnter={() => this.onEnterViewport(2)} />
			<div 
				className={classes.hero}
				style={{backgroundColor:"#59bcea"}}
			  ref={ (div) => {this.two = div}}
			>
				<QuizIntro/>
			</div>
  
			{/*<!-- Nagrade -->*/}
			<ScrollTrigger onEnter={() => this.onEnterViewport(3)} />
			<div className={classes.hero}
			 ref={ (div) => {this.three = div}}
			>
			  <div className={classes.content}>
					<ScrollTrigger 
					onEnter={({progress,velocity},ref) => this.triggerAnimation({progress,velocity},ref,'flipInY')} 
					>
					<div style={{width:'100%',textAlign:'center'}} >
						<h1 className={classes.h1Custom}>Nagrade</h1>
						{/*
						<img
						src={window.innerWidth>600 ? './prizes-title.png' : './prizes-title-mobile.png'}
						alt='PRIJAVITE SE NA LOVEUNIVERSITY.RS, POLOŽITE ZABAVNI DUREX ISPIT I MOŽETE OSVOJITI:'
						className={classes.prizeTitle}
						/>
						*/}
					</div>
					</ScrollTrigger>

				<div className={classes.cardsContent}>
				<ScrollTrigger 
					onEnter={({progress,velocity},ref) => this.triggerAnimation({progress,velocity},ref,'fadeInLeft','delay-1s')} 
					>
					<div 
						className={classes.card}
						style={{paddingTop:'8%', marginBottom:'10%'}}
					>
						{/*<img src="./dnevna.png" alt="Dnevna" style={{maxWidth:'210px',width:'90%'}}/>*/}
						<h3 className={classes.h3PresentTitle}>Dnevna</h3>
						<img src="./nagrada-3.png" alt="Poklon" style={{maxWidth:'338px',width:'90%'}}/>
						<img src="./46x.png" alt="46x" className={classes.prizeSeal1} />
						{/*<img src="./poklon-paketic.png" alt="Poklon paketić" style={{maxWidth:'338px',width:'100%'}}/>*/}
						<h4 className={classes.h4PresentText}>Poklon<br/>paketić</h4>
				  </div>
				</ScrollTrigger>
				<ScrollTrigger 
					onEnter={({progress,velocity},ref) => this.triggerAnimation({progress,velocity},ref,'fadeInUp','delay-3s')}
					>
					<div className={classes.card}
						style={{marginBottom:'10%'}}
					>
						{/*<img src="./glavna.png" alt="Glavna" style={{maxWidth:'210px',width:'90%'}}/>*/}
						<h3 className={classes.h3PresentTitle}>Glavna</h3>
						<img src="./nagrada-1.png" alt="MacBook Air" style={{maxWidth:'338px',width:'90%'}}/>
						<img src="./1x.png" alt="30x" className={classes.prizeSeal2} />
						{/*<img src="./macbook.png" alt="MacBook Air u super futroli" style={{maxWidth:'338px',width:'100%'}}/>*/}
						<h4 className={classes.h4PresentText}>MacBook Air u <br/>super futroli</h4>
				  </div>
				</ScrollTrigger>
				<ScrollTrigger 
					onEnter={({progress,velocity},ref) => this.triggerAnimation({progress,velocity},ref,'fadeInRight','delay-2s')} 
					>
					<div 
						className={classes.card}
						style={{paddingTop:'4%', marginBottom:'10%'}}
					>
						{/*<img src="./nedeljna.png" alt="Nedeljna" style={{maxWidth:'210px',width:'90%'}}/>*/}
						<h3 className={classes.h3PresentTitle}>Nedeljna</h3>
						<img src="./nagrada-2.png" alt="Poklon" style={{maxWidth:'338px',width:'90%'}}/>
						<img src="./6x.png" alt="6x" className={classes.prizeSeal3} />
						{/*<img src="./ranac.png" alt="Ranac" style={{maxWidth:'338px',width:'100%'}}/>*/}
						<h4 className={classes.h4PresentText}>Kul ranac<br/>i slušalice</h4>
				  </div>
				</ScrollTrigger>

				</div>
				<Typography
					className={classes.prizeDisclaimer}>
						Slike poklona su date isključivo za potrebe prezentovanja. Stvarni proizvodi se mogu, u manjoj meri, razlikovati u odnosu na sliku.
				</Typography>
			  </div>
			</div>			
  
  
			{/*<!-- wide div -->*/}
			<ScrollTrigger onEnter={() => this.onEnterViewport(4)} />
			<div 
			  className={classes.hero}
			  ref={ (div) => {this.four = div}}
			>
			  <div style={{backgroundColor:'#1959a0', 'height':'auto', 'width':'100%'}}>

					<TopList/>

					<WinList/>

				</div>
			</div>
			
			{/*<!-- wide div -->*/}
			<ScrollTrigger onEnter={() => this.onEnterViewport(5)} />
			<div 
			  className={classes.hero2}
			  ref={ (div) => {this.five = div}}
			>
			  <div style={{backgroundColor:'#009fdf', 'height':'auto', 'width':'100%'}}>
					<div style={{width:'100%',textAlign:'center'}} >
					{/*
								<img
								src='./kontakt.png'
								alt='Kontakt'
								className={classes.imageTitle}
								style={{maxWidth:'300px'}}
								/>
					*/}
					<h1 className={classes.h1Custom}>Kontakt</h1>
					</div>
					<div className={classes.rippedPage}>
						<img src="./ripped-paper.png" alt="" 
							style={{margin:'5vh 0'}}
						/>
						<a href="mailto:info@loveuniversity.rs"
							onClick= { () => {
								ReactGA.event({
									category: 'Navigation',
									action: 'Clicked Email Link'
								});
							}}
						>info@loveuniversity.rs</a>
					</div>
			  </div>
			</div>
  
			{/*<!-- wide div -->*/}
			<div className={classes.footer}>
					<div className={classes.footerLeft}>
						<p>&copy; Reckitt Benckiser Serbia</p>
						<p>Kampanja traje od 15. septembra do 31. oktobra 2018.</p>
					</div>
					<div className={classes.footerRight}>
						<p><a onClick={ () => {this.doClick2()}}>Pravila i uslovi učestvovanja</a></p>
						<p>Pratite nas na <img src="/fb-icon.png" alt=""/> <a 
							href="https://www.facebook.com/Durex.Srbija/" 
							target="_blank" 
							rel="noopener noreferrer"
							onClick= { () => {
								ReactGA.event({
									category: 'Navigation',
									action: 'Clicked Facebook Link - footer'
								});
							}}
						>Durex.Srbija</a></p>
					</div>
			</div>

		  </div>
			<div className={classes.SpinnerHolder}>
				{spin}
			</div>

		</div>


		);
	}
};

const mapStateToProps = state => {
	return {
		rdy: state.my.landingPageReady,
		spin: state.auth.loading,
		lpElement: state.my.landingPageElement,
		curPath: state.my.currentPath,
	};
}

const mapDispatchToProps = dispatch => {
	return {
		onRdyLanding: () => dispatch( actions.landingpageReady() ),
		spinnerChange: (spin) => dispatch ( actions.spinnerState(spin) ),
		onUpdateLPPosition: (lpPos) => dispatch ( actions.changeLandingPagePosition(lpPos) ),
		onUpdateLPElement: (lpel) => dispatch ( actions.changeLandingPageElement(lpel) ),
		onUpdatePath: (newpath) => dispatch (actions.changePath(newpath)),
	}
}



export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LandingPage));


// WEBPACK FOOTER //
// ./src/containers/LandingPage/LandingPage.js